module.exports = __webpack_public_path__ + "img/buy-already.51642c8e.png";